// Concrete (non-wild) sets used to build the standard deck.
export const ALL_SUITS = ['spades', 'hearts', 'diamonds', 'clubs'];
export const ALL_RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
export const RANK_VALUE = {
    A: 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10, J: 11, Q: 12, K: 13,
};
export const FACE_RANKS = new Set(['J', 'Q', 'K']);
export const WILD_RANK = '*';
export const WILD_SUIT = '*';
